import { withTranslation } from '@piwikpro/ui-components';
import FailMessage from './FailMessage';

export default withTranslation(['administration'])(FailMessage);
